import { AnalyticsSettings } from '@Ravnur-Inc/shared/types/AnalyticsSettings';

/**
 * Resolves the Application Insights connection string for the current tenant.
 *
 * Per-tenant configuration wins, so telemetry can be segmented and rotated
 * without a code deploy; `VUE_APP_APP_INSIGHTS_CONNECTION_STRING` is the
 * deployment-wide fallback for installations that share a single resource.
 * An empty result means telemetry is not configured - callers must skip the SDK
 * init instead of falling back to a literal.
 */
export default function getAppInsightsConnectionString(
  analytics?: AnalyticsSettings | null
): string {
  return (
    analytics?.appInsightsConnectionString ||
    analytics?.appInsightId ||
    process.env.VUE_APP_APP_INSIGHTS_CONNECTION_STRING ||
    ''
  );
}
